import { defineComponent as _defineComponent } from 'vue'
import { ISparring } from '@/types/sparring'
import { computed, ref } from 'vue'
import { IBattle } from '@/types/battle'
import api from '@/api'
import ScorelessSparring from '@/components/Battle/Sparring/ScorelessSparring.vue'

interface IProps {
  sparring: ISparring
  battle: IBattle
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SparringAdminView',
  props: {
    sparring: null,
    battle: null
  },
  emits: ["update:sparring"],
  setup(__props: any, { emit }: { emit: ({ (e: 'update:sparring', value: ISparring): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  sparring: ISparring
  battle: IBattle
};




const selectedWinner = ref<number>(props.sparring.winnerId)
const isFinishedSparring = computed(() => props.sparring.status === 'finished')
const resetLoadingBtn = ref(false)
const finishLoadingBtn = ref(false)

async function setWinner() {
  finishLoadingBtn.value = true
  const data = await api.admin.setSparringWinner({
    sparringId: props.sparring.sparringId,
    winnerId: selectedWinner.value,
  })
  finishLoadingBtn.value = false
  emit('update:sparring', data)
}

async function resetSparring() {
  resetLoadingBtn.value = true
  selectedWinner.value = props.sparring.winnerId
  const data = await api.sparrings.reset(props.sparring.sparringId)
  resetLoadingBtn.value = false
  emit('update:sparring', data)
}

return { __sfc: true,emit, props, selectedWinner, isFinishedSparring, resetLoadingBtn, finishLoadingBtn, setWinner, resetSparring, ScorelessSparring }
}

})